import { Component, Input, OnInit } from '@angular/core';
import { Discount } from 'src/app/core/models/api/discount.model';

@Component({
    selector: 'app-discounts-summary-table',
    templateUrl: './discounts-summary-table.component.html',
    styleUrls: ['./discounts-summary-table.component.scss']
})
export class DiscountsSummaryTableComponent implements OnInit {

    @Input() discounts: Discount[];
    
    constructor() { }

    ngOnInit() { }

    getMaxDiscountCode(discount: Discount) {

        return discount.discountCodes.length > 0 ? 
            discount.discountCodes.reduce((prev, current) => (prev.percentage > current.percentage) ? prev : current).percentage + '%' : "N/A";

    }

}
